import { createFileRoute, useRouter } from "@tanstack/react-router"
import { useServerFn } from "@tanstack/react-start"

import config from "@/config"

import {
  CustomerList,
  CustomerListError,
  CustomerListSkeleton,
} from "../components/customer-list/customer-list"
import {
  createCustomerAction,
  deleteCustomerAction,
  loadCustomers,
  loadInvoiceList,
  updateCustomerAction,
} from "../rpc"

export const Route = createFileRoute("/_app-shell/customers")({
  loader: async () => {
    const [customers, invoices] = await Promise.all([
      loadCustomers(),
      loadInvoiceList({ data: {} }),
    ])
    return { customers, invoices }
  },
  head: () => ({
    meta: [
      { title: `Customers - ${config.core.projectName}` },
      { name: "robots", content: "noindex" },
    ],
  }),
  pendingComponent: CustomerListSkeleton,
  errorComponent: ({ error }) => {
    const router = useRouter()
    return (
      <CustomerListError
        message={error.message || "Customers could not be loaded."}
        onRetry={() => router.invalidate()}
      />
    )
  },
  component: CustomersRoute,
})

function CustomersRoute() {
  const { customers, invoices } = Route.useLoaderData()
  const router = useRouter()
  const create = useServerFn(createCustomerAction)
  const update = useServerFn(updateCustomerAction)
  const remove = useServerFn(deleteCustomerAction)

  return (
    <CustomerList
      customers={customers}
      invoices={invoices}
      onSubmitCustomer={(id, request) =>
        id === null ? create({ data: request }) : update({ data: { id, request } })
      }
      onDelete={(id) => remove({ data: { id } })}
      onChanged={() => void router.invalidate()}
    />
  )
}
